import positionLevelAPI from '@/api/master-data/position-level/position-level';

const state = () => ({
  isLoading: false,
  positionLevelData: [],
  totalRecords: 0
});

const mutations = {
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_POSITION_LEVEL_DATA(state, data) {
    state.positionLevelData = data;
  },
  SET_TOTAL_RECORDS(state, total) {
    state.totalRecords = total;
  }
};

const getters = {
  getLoading: (state) => state.isLoading,
  getPositionLevelData: (state) => state.positionLevelData,
  getTotalRecords: (state) => state.totalRecords
};

const actions = {
  async getPositionLevelList({ commit }, params) {
    commit('SET_LOADING', true);
    try {
      const response = await positionLevelAPI.getPositionLevels(params);
      
      let positionLevelData = [];
      let total = 0;
      
      if (response.data.data.data) {
        positionLevelData = Array.isArray(response.data.data.data) ? response.data.data.data : [];
        total = response.data.data.totalItems;
      }
      
      commit('SET_POSITION_LEVEL_DATA', positionLevelData);
      commit('SET_TOTAL_RECORDS', total);
    } catch (error) {
      console.error('Error fetching position levels:', error);
      commit('SET_POSITION_LEVEL_DATA', []);
      commit('SET_TOTAL_RECORDS', 0);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async getPositionLevelById({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      const response = await positionLevelAPI.getPositionLevelById(id);
      return response.data;
    } catch (error) {
      console.error('Error fetching position level detail:', error);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async createPositionLevel({ commit }, data) {
    commit('SET_LOADING', true);
    try {
      const response = await positionLevelAPI.createPositionLevel(data);
      return response.data;
    } catch (error) {
      console.error('Error creating position level:', error);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async updatePositionLevel({ commit }, { id, data }) {
    commit('SET_LOADING', true);
    try {
      const response = await positionLevelAPI.updatePositionLevel(id, data);
      return response.data;
    } catch (error) {
      console.error('Error updating position level:', error);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async deletePositionLevel({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      const response = await positionLevelAPI.deletePositionLevel(id);
      return response.data;
    } catch (error) {
      console.error('Error deleting position level:', error);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
